import React from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import ProjectsList from "../../../common/components/Projects/ProjectsScroll";


const ProjectsSection = ({ projects, lang, isHorizontal }) => {

    return (
        <>
            {projects?.length > 0 && <>
                <div className="py-6">
                    <div className="container text-center translate-dynamic">
                        <div className="mb-5 center mw-800px font-etihad color-secondary">
                            <h3
                                style={{
                                    maxWidth: '500px',
                                    marginLeft: 'auto',
                                    marginRight: 'auto'
                                }}
                                className="color-secondary"
                            >
                                Supporting projects that make a contribution to the planet & people
                            </h3>
                            <p style={{ fontSize: '1.25rem' }}>CarbonClick supports high-quality carbon offsetting projects both locally and internationally. See our project selection below.</p>
                        </div>
                        <div className="projects-section font-etihad-important color-secondary text-align-start img-rounded white-project-basket mobile-text-center">
                            <ProjectsList isHorizontal={isHorizontal} title={null} projects={projects} lang={lang} />
                        </div>
                    </div>
                </div>
            </>}
        </>
    )
}


export default ProjectsSection;